import { render } from "./Browser.vue?vue&type=template&id=5cc80237&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=5cc80237&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc80237"]])

export default __exports__